import type { UILocation } from "@1js/acui-common";
import { dataUniqueId } from "@1js/acui-common";

/**
 * Minimum properties associated with the `data-unique-id` property.
 */

export type StateWithDataUniqueId = {
  root: {
    "data-unique-id"?: string;
  };
};

/**
 * Process the `state` as a mutable draft state and set the `data-unique-id` property
 * according to either `valueOrDefaultValue` or the results of `dataUniqueId`.
 */
export function useDataUniqueId<T extends StateWithDataUniqueId>(
  state: T,
  id?: string,
  location?: UILocation
) {
  const uniqueId = dataUniqueId({ id, location });
  if (uniqueId !== undefined) {
    state.root["data-unique-id"] = uniqueId;
  }
}
